// MaterialSlot is an optional zero-based glTF primitive/material slot. Use
// source associations, never the currently assigned material (which changes
// as options are selected).
export function materialStateTargetSlot(target) {
    if (Object.hasOwn(target, "MaterialSlot")) return target.MaterialSlot;
    // Before slot metadata existed, Unity MaterialStates always changed slot 0.
    // Base Renderer and untyped web targets retain whole-renderer behavior.
    return /^UnityEngine\.(MeshRenderer|SkinnedMeshRenderer)(?:,|$)/.test(target.ComponentType ?? "")
        ? 0 : undefined;
}

export function materialAssignments(object, slot, primitiveIndices) {
    const assignments = [];
    object?.traverse(mesh => {
        if (!mesh.isMesh) return;
        if (slot != null && mesh !== object && (object.isMesh || mesh.parent !== object)) return;
        const primitive = primitiveIndices?.get(mesh);
        if (Array.isArray(mesh.material)) {
            mesh.material.forEach((material, index) => {
                if (slot == null || index === slot) assignments.push({ mesh, index, material });
            });
        } else if (slot == null || primitive === slot || (primitive == null && object === mesh && slot === 0)) {
            assignments.push({ mesh, index: null, material: mesh.material });
        }
    });
    return assignments;
}

export function assignMaterial({ mesh, index }, material) {
    if (index === null) mesh.material = material;
    else { mesh.material = [...mesh.material]; mesh.material[index] = material; }
}
